export const DEMO_COMPANY_LEADERBOARD_EMAIL = 'demo@snowsproam.com';
export const DEMO_SMBC_TOTAL_STEPS = 8248960;
export const DEMO_COMPANY_TOTAL_STEPS = 7855872;
export const DEMO_COMPANY_INSTITUTE_NAMES = [
  'SMBC Aviation Capital',
  'SMBC Aviation Capital Departments',
  'SMBC Aviation Capital Members',
  'SMBC Aviation Capital Move Together 50K',
  'EY',
  'EY Departments',
  'EY Members',
  'EY Consulting',
  'EY Consulting Departments',
  'EY Consulting Members',
  'Bluewave Enterprise',
  'Bluewave Enterprise Departments',
  'Bluewave Enterprise Members',
];

const logoUrl = (domain) => `https://www.google.com/s2/favicons?sz=128&domain=${domain}`;
const DEMO_EY_LOGO_URL = 'https://media.snowsproam.com/Demo-Institute/ey-company-logo.png';
const DEMO_SMBC_LOGO_URL = 'https://media.snowsproam.com/Demo-Institute/SMBC-Aviation-Capital/smbc-aviation-capital-logo.png';
const CUSTOM_COMPANY_LOGOS = {
  'SMBC Aviation Capital': DEMO_SMBC_LOGO_URL,
  EY: DEMO_EY_LOGO_URL,
  'EY Consulting': DEMO_EY_LOGO_URL,
  Deloitte: 'https://media.snowsproam.com/Demo-Institute/deloitte-official-logo.png',
  KPMG: 'https://kpmg.com/content/experience-fragments/kpmgpublic/xx/en/site/header/master/_jcr_content/root/header/logo.coreimg.svg/1724184164104/logo.svg',
};

const DEMO_COMPANY_ROWS = [
  ['SMBC Aviation Capital', 'smbc.aero', 'Dublin, Ireland', DEMO_SMBC_TOTAL_STEPS],
  ['EY', '', 'Dublin, Ireland', DEMO_COMPANY_TOTAL_STEPS],
  ['Deloitte', 'deloitte.com', 'Dublin, Ireland', 7218440],
  ['PwC', 'pwc.com', 'Dublin, Ireland', 7040905],
  ['KPMG', 'kpmg.com', 'Dublin, Ireland', 6887710],
  ['Apple', 'apple.com', 'Dublin, Ireland', 6542140],
  ['Microsoft', 'microsoft.com', 'Dublin, Ireland', 6318875],
  ['Google', 'google.com', 'Dublin, Ireland', 6092040],
  ['Amazon', 'amazon.com', 'Dublin, Ireland', 5846415],
  ['NVIDIA', 'nvidia.com', 'Dublin, Ireland', 5520020],
  ['Samsung', 'samsung.com', 'Dublin, Ireland', 5298760],
  ['Meta', 'meta.com', 'Dublin, Ireland', 5064410],
  ['Tesla', 'tesla.com', 'Dublin, Ireland', 4720985],
  ['Netflix', 'netflix.com', 'Dublin, Ireland', 3718440],
  ['Adobe', 'adobe.com', 'Dublin, Ireland', 3540905],
  ['Oracle', 'oracle.com', 'Dublin, Ireland', 3387710],
  ['Salesforce', 'salesforce.com', 'Dublin, Ireland', 3246185],
  ['Sony', 'sony.com', 'Dublin, Ireland', 3095520],
  ['IBM', 'ibm.com', 'Dublin, Ireland', 2948890],
  ['Intel', 'intel.com', 'Dublin, Ireland', 2810435],
  ['Spotify', 'spotify.com', 'Dublin, Ireland', 2674010],
  ['Airbnb', 'airbnb.com', 'Dublin, Ireland', 2539925],
  ['Uber', 'uber.com', 'Dublin, Ireland', 2418760],
  ['Nike', 'nike.com', 'Dublin, Ireland', 2295405],
  ['Coca-Cola', 'coca-cola.com', 'Dublin, Ireland', 2167090],
  ['Disney', 'disney.com', 'Dublin, Ireland', 2054885],
  ['Shopify', 'shopify.com', 'Dublin, Ireland', 1937140],
  ['Stripe', 'stripe.com', 'Dublin, Ireland', 1819925],
  ['Zoom', 'zoom.us', 'Dublin, Ireland', 1704550],
];

export const isDemoCompanyLeaderboard = (email, type) =>
  String(email || '').toLowerCase() === DEMO_COMPANY_LEADERBOARD_EMAIL &&
  String(type || '').toLowerCase() === 'company';

export const isDemoCompanyInstituteRow = (row = {}) =>
  DEMO_COMPANY_INSTITUTE_NAMES.some(
    (name) => String(row?.name || '').toLowerCase() === name.toLowerCase(),
  );

export const buildDemoCompanyLeaderboard = () =>
  DEMO_COMPANY_ROWS.map(([name, domain, location, totalSteps], index) => {
    const [region, country] = String(location).split(',').map(part => part.trim());
    const isEyDemoCompany = name === 'EY';
    const rowLogoUrl = CUSTOM_COMPANY_LOGOS[name] || logoUrl(domain);
    return {
      id: isEyDemoCompany ? 'demo-ey-consulting' : `demo-company-${String(name).toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
      name,
      type: 'Company',
      institute_type: 'Company',
      region,
      state_province: region,
      country,
      image_url: rowLogoUrl,
      brand_logo_url: rowLogoUrl,
      totalSteps,
      accessLocked: false,
      access_active: true,
      billing_status: 'active',
      rank: index + 1,
    };
  });
